import { render, staticRenderFns } from "./InstagramImage.vue?vue&type=template&id=bf91f0a2&functional=true&"
import script from "./InstagramImage.vue?vue&type=script&lang=js&"
export * from "./InstagramImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports